import React, { useEffect, useRef, useState } from "react";
import { MAIN_URL } from "../../../../Configs/Urls";
import CloseIcon from "../../../../Assets/Images/closeico--userdb.svg";
import CollapseIcon from "../../../../Assets/Images/collapsed--ico.svg";
import CheckBlueIcon from "../../../../Assets/Images/checkblue.svg";
import CalenderIcon from "../../../../Assets/Images/calendarico.svg";

import "./formStyle.css";
import axios from "axios";
import { toast } from "react-toastify";
import Popup from "./BookingPopup";
import CalendarPopup from "./CalendarPopup";
import { useSelector } from "react-redux";
import { getLocalStorageJSON } from "../../../../Utils/localStorageFunc";
import Popup1 from "../../../Components/Popups/ModalPopup/Popup1";

// testing for this  ...........

// when for a trip all unblocked travellers are selected + prceed to ignore is 0 then show that alrert

const areAllTripsDisabled = (MainForm) => {
  if (!MainForm?.data?.form_data?.length) return false;

  return MainForm.data.form_data.every((trip) => isTripPastOrDeparted(trip));
};

const isTripPastOrDeparted = (trip) => {
  if (!trip?.Data?.length) return false;

  const departureTimes = trip.Data
    .map((d) => d.departure_date_and_time ? new Date(d.departure_date_and_time) : null)
    .filter((d) => d && !isNaN(d.getTime()));

  if (departureTimes.length === 0) return false;

  const earliestDeparture = new Date(
    Math.min(...departureTimes.map((d) => d.getTime()))
  );

  const now = new Date();

  return earliestDeparture <= now;
};

const isFramePastOrDeparted = (frame) => {
  if (!frame?.departure_date_and_time) return false;
  const d = new Date(frame.departure_date_and_time);
  if (isNaN(d.getTime())) return false;
  return d <= new Date();
};

const isTripFullySelected = (trip, tripIndex, selectedTravellers) => {
  if (!trip?.Data) return false;

  const unblockedTravellers = trip.Data.flatMap((frame) =>
    frame.travellers.filter((t) => !t.is_blocked || t.available_for_other_enquiry)
  );

  if (unblockedTravellers.length === 0) return false;

  return unblockedTravellers.every((t) =>
    selectedTravellers.includes(t.ref_id)
  );
};

function ReschedulingForm({
  showbottombar,
  getApi,
  postApi,
  booking_id,
  onClose,
  autoFill,
  documentData,
  readOnly,
  formId,
  requestId,
  ancillaryOnly = false,
}) {
  let [warningMessage, setWarningMessage] = useState("");

  const isDateMissingForTraveller = (trv) => {
    return selectedTravellers.includes(trv.ref_id) && !trv.reschedule_date_1;
  };


  const { isUserLogin, isAdminLogin, userLoggedInData } = useSelector(
    (state) => state.user
  );

  const [loading, setLoading] = useState(true);
  const [MainForm, setMainForm] = useState(null);

  const [pendingEnquiry, setPendingEnquiry] = useState(null);
  const [existingRemarks, setExistingRemarks] = useState([]);
  const [newRemark, setNewRemark] = useState("");
  const [savingRemark, setSavingRemark] = useState(false);
  const [remarkCooldownSecs, setRemarkCooldownSecs] = useState(0);
  const [remarkFiles, setRemarkFiles] = useState([]);
  const [selectedEnquiryTravellerIds, setSelectedEnquiryTravellerIds] = useState([]);

  const [Remarks, setRemarks] = useState({
    user_remarks_1: "",
    user_remarks_2: "",
    user_remarks_3: "",
    user_remarks_4: "",
  });

  const [ProceedMode, setProceedMode] = useState({
    proceed_mode_1: 0,
    proceed_mode_2: 0,
    proceed_mode_3: 0,
    proceed_mode_4: 0,
  });

  const [AcceptFareRules, setAcceptFareRules] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [Documents, setDocuments] = useState({
    trip_1: [],
    trip_2: [],
    trip_3: [],
    trip_4: [],
  });

  const [openDP, setOpenDP] = useState(null);
  const [openBulkDP, setOpenBulkDP] = useState(null);

  console.log("openBulkDP is : ", openBulkDP);

  const fixUrl = (url) => url ? url.replace(/([^:])\/\//g, "$1/") : url;

  const handleDocumentChange = (tripKey, files) => {
    const newDocs = Array.from(files).map((file) => ({
      name: file.name,
      url: URL.createObjectURL(file),
      isExisting: false,
      file,
    }));

    setDocuments((prev) => ({
      ...prev,
      [tripKey]: [...prev[tripKey], ...newDocs],
    }));
  };

  const removeDocument = (tripKey, index) => {
    setDocuments((prev) => ({
      ...prev,
      [tripKey]: prev[tripKey].filter((_, i) => i !== index),
    }));
  };

  console.log("Form is : ", MainForm);

  useEffect(() => {
    if (!booking_id) return;

    const fetchForm = async () => {
      try {
        setLoading(true);

        const token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");

        // query_type lets the backend detect ancillary mode before an enquiry exists yet
        // (this is the "raise request" flow — the enquiry is only created on submit), so it
        // can split multi-segment trips into one selectable row per segment.
        const res = await axios.get(`${getApi}/${booking_id}?query_type=${encodeURIComponent(ancillaryOnly ? 'reschedule_add_ancillaries' : '')}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log("GET API RESPONSE => ", res.data);

        setMainForm(res.data);

        let maind = res.data.data;
        console.log("maind is : ", maind);

        setRemarks({
          user_remarks_1: maind.user_remarks_1 ?? "",
          user_remarks_2: maind.user_remarks_2 ?? "",
          user_remarks_3: maind.user_remarks_3 ?? "",
          user_remarks_4: maind.user_remarks_4 ?? "",
        });

        setProceedMode({
          proceed_mode_1: maind.proceed_mode_1 ?? 0,
          proceed_mode_2: maind.proceed_mode_2 ?? 0,
          proceed_mode_3: maind.proceed_mode_3 ?? 0,
          proceed_mode_4: maind.proceed_mode_4 ?? 0,
        });

        const initialOpen = {};

        res.data.data.form_data.forEach((_, idx) => {
          initialOpen[idx] = true;
        });

        setOpenTrips(initialOpen);

        const backendDocs = res.data.documents || [];

        const mappedDocs = {
          trip_1: [],
          trip_2: [],
          trip_3: [],
          trip_4: [],
        };

        backendDocs.forEach((doc) => {
          const tripKey = doc.document_for || "trip_1"; // fallback if null

          const fileName = doc.document_link.split("/").pop();

          if (mappedDocs[tripKey]) {
            mappedDocs[tripKey].push({
              name: fileName,
              url: doc.document_link,
              isExisting: true,
            });
          }
        });

        setDocuments(mappedDocs);

        // Pre-fill want fields and restore selected travellers
        const wantPrefill = {};
        const autoSelected = [];
        const autoStatuses = [];
        (res.data?.data?.form_data || []).forEach((trip) => {
          (trip.Data || []).forEach((frame) => {
            (frame.travellers || []).forEach((trv) => {
              // Always prefill want fields. In ancillary mode the backend scopes trv.ref_id
              // to this single segment only, so ref_id is already the correct per-segment key.
              wantPrefill[trv.ref_id] = {
                want_seat: !!trv.want_seat,
                want_meal: !!trv.want_meal,
                want_bag: !!trv.want_bag,
                want_wheelchair: !!trv.want_wheelchair,
                wanted_seat_value: trv.wanted_seat_value || "",
                wanted_meal_value: trv.wanted_meal_value || "",
                wanted_bag_value: trv.wanted_bag_value || "",
              };
              // Restore selected travellers from saved state
              if (trv.selected_for_reschedule) {
                autoSelected.push(trv.ref_id);
                if (Array.isArray(trv.statusTypes)) autoStatuses.push(...trv.statusTypes);
              }
            });
          });
        });
        setTravellerWantFields(wantPrefill);
        if (autoSelected.length > 0) {
          setSelectedTravelers((prev) => Array.from(new Set([...prev, ...autoSelected])));
          setSelectedStatuses((prev) => Array.from(new Set([...prev, ...autoStatuses])));
        }
      } catch (err) {
        console.error("GET API FAILED => ", err);
      } finally {
        setLoading(false);
      }
    };

    if (readOnly && formId) {
      setPendingEnquiry({ has_pending: true, form_id: formId });
      const fetchSavedForm = async () => {
        try {
          setLoading(true);
          const token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
          const [formRes, remarkRes] = await Promise.all([
            axios.get(`${MAIN_URL}bookings/flights/post-booking-form-by-id/${formId}`, {
              headers: { Authorization: `Bearer ${token}` },
            }),
            axios.get(`${MAIN_URL}bookings/flights/post-booking-form-remarks/${formId}`, {
              headers: { Authorization: `Bearer ${token}` },
            }),
          ]);

          setMainForm(formRes.data);
          setExistingRemarks(remarkRes.data.remarks || []);

          setRemarks({
            user_remarks_1: formRes.data.user_remarks_1 ?? "",
            user_remarks_2: formRes.data.user_remarks_2 ?? "",
            user_remarks_3: formRes.data.user_remarks_3 ?? "",
            user_remarks_4: formRes.data.user_remarks_4 ?? "",
          });
          setProceedMode({
            proceed_mode_1: formRes.data.proceed_mode_1 ?? 0,
            proceed_mode_2: formRes.data.proceed_mode_2 ?? 0,
            proceed_mode_3: formRes.data.proceed_mode_3 ?? 0,
            proceed_mode_4: formRes.data.proceed_mode_4 ?? 0,
          });

          const initialOpen = {};
          (formRes.data.data?.form_data || []).forEach((_, idx) => {
            initialOpen[idx] = true;
          });
          setOpenTrips(initialOpen);

          const backendDocs = formRes.data.documents || [];
          const mappedDocs = { trip_1: [], trip_2: [], trip_3: [], trip_4: [] };
          backendDocs.forEach((doc) => {
            const tripKey = doc.document_for || "trip_1";
            const fileName = doc.document_link.split("/").pop();
            if (mappedDocs[tripKey]) {
              mappedDocs[tripKey].push({ name: fileName, url: doc.document_link, isExisting: true });
            }
          });
          setDocuments(mappedDocs);
          setSelectedEnquiryTravellerIds(formRes.data.selected_traveller_ids || []);
        } catch (err) {
          console.error("fetchSavedForm error", err);
        } finally {
          setLoading(false);
        }
      };
      fetchSavedForm();
      return;
    } else {
      // Check if a pending rescheduling enquiry already exists for this booking
      const checkPending = async () => {
        try {
          const token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
          const res = await axios.get(
            `${MAIN_URL}bookings/flights/check-pending-enquiry/${booking_id}/reschedule`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          setPendingEnquiry(res.data);
          setExistingRemarks(res.data.remarks || []);
        } catch (err) {
          console.error("checkPendingEnquiry error", err);
        }
      };
      checkPending();
    }

    if (autoFill.autoFilled == false) {
      fetchForm();
    } else {
      setMainForm(autoFill.data);

      setRemarks({
        user_remarks_1: autoFill.data.data.user_remarks_1 ?? "",
        user_remarks_2: autoFill.data.data.user_remarks_2 ?? "",
        user_remarks_3: autoFill.data.data.user_remarks_3 ?? "",
        user_remarks_4: autoFill.data.data.user_remarks_4 ?? "",
      });

      setProceedMode({
        proceed_mode_1: autoFill.data.data.proceed_mode_1 ?? 0,
        proceed_mode_2: autoFill.data.data.proceed_mode_2 ?? 0,
        proceed_mode_3: autoFill.data.data.proceed_mode_3 ?? 0,
        proceed_mode_4: autoFill.data.data.proceed_mode_4 ?? 0,
      });

      const initialOpen = {};

      autoFill.data.data.form_data.forEach((_, idx) => {
        initialOpen[idx] = true;
      });

      setOpenTrips(initialOpen);

      setDocuments(documentData);

      setLoading(false);
    }
  }, [booking_id, autoFill, readOnly, formId]);

  const scrollRef = useRef(null);
  let [selectedTravellers, setSelectedTravelers] = useState([]);
  let [selectedStatuses, setSelectedStatuses] = useState([]);
  const [travellerWantFields, setTravellerWantFields] = useState({});

  const [openTrips, setOpenTrips] = useState({});

  const isTravellerDateMissing = (traveller) => {
    return (
      selectedTravellers.includes(traveller.ref_id) &&
      !traveller.reschedule_date_1
    );
  };

  const hasMissingDates = () => {
    if (!MainForm?.data?.form_data) return false;

    for (const trip of MainForm.data.form_data) {
      for (const frame of trip.Data) {
        for (const trv of frame.travellers) {
          if (
            selectedTravellers.includes(trv.ref_id) &&
            !trv.reschedule_date_1
          ) {
            return true;
          }
        }
      }
    }
    return false;
  };

  const toggleTrip = (index) => {
    setOpenTrips((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // Parse "DD/MM/YYYY" → "YYYY-MM-DD" for calendar minDate and comparisons
  const toISODate = (ddmmyyyy) => {
    if (!ddmmyyyy) return null;
    if (ddmmyyyy.includes("-")) return ddmmyyyy; // already YYYY-MM-DD
    const [dd, mm, yyyy] = ddmmyyyy.split("/");
    if (!dd || !mm || !yyyy) return null;
    return `${yyyy}-${mm}-${dd}`;
  };

  // Returns the minDate (YYYY-MM-DD) for a traveller's date picker based on the previous frame's date.
  const getMinDateForTraveller = (trpIdx, frameIdx, traveller) => {
    const today = new Date().toISOString().split("T")[0];
    if (frameIdx === 0) return today;

    const trip = MainForm?.data?.form_data?.[trpIdx];
    if (!trip) return today;

    for (let fi = frameIdx - 1; fi >= 0; fi--) {
      const prevFrame = trip.Data[fi];
      if (!prevFrame) continue;
      const match = prevFrame.travellers.find(
        (t) => t.full_name === traveller.full_name && t.date_of_birth === traveller.date_of_birth
      );
      if (match?.reschedule_date_1) {
        const iso = toISODate(match.reschedule_date_1);
        return iso > today ? iso : today;
      }
    }
    return today;
  };

  // For bulk picker: use the strictest (latest) minDate across all travellers in the frame
  const getMinDateForFrame = (trpIdx, frameIdx, travellers) => {
    const today = new Date().toISOString().split("T")[0];
    if (frameIdx === 0) return today;

    let maxMin = today;
    travellers.forEach((trv) => {
      const d = getMinDateForTraveller(trpIdx, frameIdx, trv);
      if (d > maxMin) maxMin = d;
    });
    return maxMin;
  };

  const getAutoRescheduleTrips = () => {
    if (!MainForm?.data?.form_data) return [];

    return MainForm.data.form_data
      .map((trip, index) => {
        const tripNo = index + 1;
        const fullySelected = isTripFullySelected(
          trip,
          index,
          selectedTravellers
        );
        const proceedMode = ProceedMode[`proceed_mode_${tripNo}`];

        if (fullySelected && proceedMode === 0) {
          return `Trip ${tripNo}`;
        }

        return null;
      })
      .filter(Boolean);
  };

  const allTripsDisabled = areAllTripsDisabled(MainForm);

  const handleSubmit = async () => {
    if (selectedTravellers.length === 0) {
      setWarningMessage(
        "Please select at least one traveller for Rescheduling."
      );
      return;
    }

    if (allTripsDisabled) {
      setWarningMessage(
        "All trips have already departed. Rescheduling is not allowed."
      );
      return;
    }

    // Ancillary mode: a ticked traveller must have at least one of seat/meal/bag/wheelchair
    // chosen — otherwise the tick means nothing and the request would submit with zero
    // actual changes.
    if (ancillaryOnly) {
      const missingWant = selectedTravellers.some((refId) => {
        const w = travellerWantFields[refId] || {};
        return !w.want_seat && !w.want_meal && !w.want_bag && !w.want_wheelchair;
      });
      if (missingWant) {
        setWarningMessage(
          "Please select at least one of Seat / Meal / Bag / Wheelchair for every ticked traveller."
        );
        return;
      }
    }

    if (!ancillaryOnly && !AcceptFareRules) {
      setWarningMessage("Please Accept the Fare Rules.");
      return;
    }

    const autoTrips = getAutoRescheduleTrips(selectedTravellers);


    // ✅ Build reschedule_date array: traveller_id => "date1|date2"
    const rescheduleDateMap = {};

    MainForm.data.form_data.forEach((trip) => {
      trip.Data.forEach((frame) => {
        frame.travellers.forEach((trv) => {
          // Only include selected travellers
          if (selectedTravellers.includes(trv.ref_id)) {
            const date1 = trv.reschedule_date_1 || null;
            const date2 = trv.reschedule_date_2 || null;

            // Format: "date1|date2" or just "date1" if no date2
            if (date1) {
              rescheduleDateMap[trv.ref_id] = date2
                ? `${date1}|${date2}`
                : date1;
            }
          }
        });
      });
    });

    // ✅ Validate that all selected travellers have dates
    const missingDates = selectedTravellers.filter(
      (id) => !rescheduleDateMap[id]
    );

    if (missingDates.length > 0) {
      setWarningMessage(
        "Please set reschedule dates for all selected travellers."
      );
      return;
    }

    const formData = new FormData();
    formData.append("booking_id", booking_id);
    formData.append("user_id", userLoggedInData.id);
    formData.append("submittion_type", "admin");
    if (ancillaryOnly) {
      formData.append("existing_booking_query_type", "reschedule_add_ancillaries");
    }

    // ✅ Send remarks as object-like array
    Object.entries(Remarks).forEach(([key, value]) => {
      formData.append(`remarks[${key}]`, value);
    });

    // ✅ Send proceed_mode as object-like array
    Object.entries(ProceedMode).forEach(([key, value]) => {
      formData.append(`proceed_mode[${key}]`, value);
    });

    // ✅ Attach traveller IDs (with full ref format like "123-456")
    selectedTravellers.forEach((id) => {
      formData.append("traveller_ids[]", id);
    });

    // ✅ Attach status types
    selectedStatuses.forEach((st) => {
      formData.append("status_types[]", st);
    });

    // ✅ Attach reschedule_date array: reschedule_date[traveller_id] = "date1|date2"
    Object.entries(rescheduleDateMap).forEach(([travellerId, dateString]) => {
      // formData.append(`reschedule_date[${travellerId}]`, dateString);

      let splittedIds = travellerId.split("-");

      formData.append(`reschedule_date[${splittedIds[0]}]`, dateString);
      formData.append(`reschedule_date[${splittedIds[1]}]`, dateString);
    });

    // ✅ Attach seat/meal/bag/wheelchair want fields per segment — travellerWantFields is keyed by
    // the individual per-segment traveller row id, so each segment of a multi-segment trip is
    // submitted independently instead of only the first segment.
    selectedTravellers.forEach((refId) => {
      const ids = String(refId).split("-").filter(Boolean);
      if (!ids.length) return;
      ids.forEach((id) => {
        const w = travellerWantFields[id] || travellerWantFields[refId] || {};
        formData.append(`want_seat[${id}]`, w.want_seat ? "1" : "0");
        formData.append(`want_meal[${id}]`, w.want_meal ? "1" : "0");
        formData.append(`want_bag[${id}]`, w.want_bag ? "1" : "0");
        formData.append(`want_wheelchair[${id}]`, w.want_wheelchair ? "1" : "0");
        if (w.want_seat && w.wanted_seat_value) formData.append(`wanted_seat_value[${id}]`, w.wanted_seat_value);
        if (w.want_meal && w.wanted_meal_value) formData.append(`wanted_meal_value[${id}]`, w.wanted_meal_value);
        if (w.want_bag && w.wanted_bag_value) formData.append(`wanted_bag_value[${id}]`, w.wanted_bag_value);
      });
    });

    // ✅ Attach documents (optional)
    Object.entries(Documents).forEach(([tripKey, docs]) => {
      docs.forEach((doc, idx) => {
        if (!doc.isExisting && doc.file) {
          formData.append(`documents[${tripKey}_${idx}][file]`, doc.file);
          formData.append(
            `documents[${tripKey}_${idx}][document_for]`,
            tripKey
          );
        }
      });
    });

    // Debug: Log what we're sending
    console.log("=== SUBMIT DATA ===");
    console.log("Selected Travellers:", selectedTravellers);
    console.log("Reschedule Date Map:", rescheduleDateMap);
    console.log("Selected Statuses:", selectedStatuses);

    setSubmitting(true);
    try {
      const token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");

      const res = await axios.post(postApi, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("POST RESULT => ", res.data);
      toast.success("Reschedule request submitted!");
      onClose();
    } catch (err) {
      console.error("POST ERROR => ", err);
      toast.error("Failed to submit");
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (warningMessage !== "") {
      const timer = setTimeout(() => {
        setWarningMessage("");
      }, 3000); // 3 seconds

      // cleanup to avoid memory leaks
      return () => clearTimeout(timer);
    }
  }, [warningMessage]);

  const REMARK_COOLDOWN_MS = 10 * 60 * 1000;
  const getRemarkCooldownKey = () => `remark_cooldown_reschedule_${pendingEnquiry?.form_id}`;

  useEffect(() => {
    if (!pendingEnquiry?.form_id) return;
    const stored = localStorage.getItem(getRemarkCooldownKey());
    if (stored) {
      const remaining = Math.ceil((parseInt(stored) + REMARK_COOLDOWN_MS - Date.now()) / 1000);
      if (remaining > 0) setRemarkCooldownSecs(remaining);
    }
  }, [pendingEnquiry?.form_id]);

  useEffect(() => {
    if (remarkCooldownSecs <= 0) return;
    const t = setInterval(() => {
      setRemarkCooldownSecs((prev) => {
        if (prev <= 1) { clearInterval(t); return 0; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [remarkCooldownSecs]);

  const handleSaveRemark = async () => {
    if (!newRemark.trim() && remarkFiles.length === 0) return;
    if (!pendingEnquiry?.form_id) return;
    if (remarkCooldownSecs > 0) return;
    try {
      setSavingRemark(true);
      const token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
      const fd = new FormData();
      fd.append("air_booking_post_booking_forms_id", pendingEnquiry.form_id);
      if (newRemark.trim()) fd.append("remarks", newRemark.trim());
      remarkFiles.forEach((f) => fd.append("attachments[]", f));
      await axios.post(
        `${MAIN_URL}bookings/flights/post-booking-form-remarks`,
        fd,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
      );
      const res = await axios.get(
        `${MAIN_URL}bookings/flights/post-booking-form-remarks/${pendingEnquiry.form_id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setExistingRemarks(res.data.remarks || []);
      setNewRemark("");
      setRemarkFiles([]);
      localStorage.setItem(getRemarkCooldownKey(), Date.now().toString());
      setRemarkCooldownSecs(REMARK_COOLDOWN_MS / 1000);
      toast.success("Remark saved!");
    } catch (err) {
      console.error("Save remark error", err);
      toast.error("Failed to save remark");
    } finally {
      setSavingRemark(false);
    }
  };

  const hasPending = readOnly && pendingEnquiry?.has_pending === true;
  const showRemarksPanel = hasPending;

  console.log("Documents is : ", Documents);

  console.log("hasMissingDates is : ", hasMissingDates());
  console.log("allTripsDisabled is : ", allTripsDisabled);
  console.log(
    "autoFill?.autoFilled == true && is : ",
    autoFill?.autoFilled == true && autoFill.data.submittion_type != "admin"
  );

  console.log(
    "DISABLED FINAL VALUE =>",
    allTripsDisabled ||
    hasMissingDates() ||
    (autoFill?.autoFilled == true && autoFill.data.submittion_type != "admin")
  );

  return (
    <div style={{ width: showRemarksPanel ? "1300px" : "1000px" }}>
      <div className="res--booking--header">
        <div style={{ display: "flex", alignItems: "center", gap: "25px" }}>
          <h3 style={{ margin: "0px" }}>{ancillaryOnly ? 'Add Addons Booking' : 'Reschedule Booking'}</h3>
          {requestId && (
            <span style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "3px 10px" }}>
              REQ #{requestId}
            </span>
          )}
          {warningMessage && (
            <p
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "white",
                padding: "5px 10px",
                borderRadius: "5px",
                background: "red",
              }}
            >
              {warningMessage}
            </p>
          )}
        </div>
        <img src={CloseIcon} alt="" />
      </div>
      {loading ? (
        <h4>Loading Please Wait...</h4>
      ) : (
        <div style={{ display: "flex", gap: 0, alignItems: "stretch" }}>
          {/* ── LEFT: form ── */}
          <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", position: "relative" }}>
          <div ref={scrollRef} style={{ maxHeight: "500px", overflow: "auto" }}>
            <div>
            {MainForm?.data?.form_data?.map((trip, trpIdx) => {
              const isTripDisabled = isTripPastOrDeparted(trip);

              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    opacity: isTripDisabled ? 0.5 : 1,
                    pointerEvents: isTripDisabled ? "none" : "auto",
                  }}
                  className={`fi--tripinfo--container fi--tripinfo--cancellation ${isTripDisabled ? "trip-disabled" : ""
                    }`}
                  key={trpIdx}
                >
                  <div className="fi--tripinfo--left">
                    {isTripDisabled && (
                      <span className="trip-disabled-text">
                        Flight already departed — rescheduling not allowed
                      </span>
                    )}

                    <div className="ticket--head--userdb">
                      <div className="ticket--head--data--left">
                        <div className="ticket--onward-return--timings">
                          <div className="ticket--onward--return">
                            {trip?.main_heading} Flight Details
                          </div>
                        </div>

                        <div className="ticket--subflight--details">
                          {trip?.Head_Data?.map((hd, hdx) => {
                            return (
                              <div className="route--row" key={hdx}>
                                <div className="left--route--row">
                                  <div className="route--row--source">
                                    {trip?.Head_Data?.length > 2
                                      ? hd.airport_code_from
                                      : hd.from}
                                  </div>
                                  <div className="route--row--stops">
                                    -{" "}
                                    {hd.stops == 0
                                      ? "Non Stop"
                                      : `${hd.stops} Stops`}{" "}
                                    -
                                  </div>
                                  <div className="route--row--source">
                                    {trip?.Head_Data?.length > 2
                                      ? hd.airport_code_to
                                      : hd.to}
                                  </div>

                                  {hdx !== trip?.Head_Data?.length - 1 && ", "}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div className="ticket--head--data--right">
                        <img
                          className={`collapse-icon ${openTrips[trpIdx] ? "open" : ""
                            }`}
                          onClick={() => toggleTrip(trpIdx)}
                          src={CollapseIcon}
                          alt=""
                          srcset=""
                        />
                      </div>
                    </div>

                    {openTrips[trpIdx] && (
                      <>
                        {!ancillaryOnly && MainForm?.data?.form_data?.length == 1 && (
                          <div className="tripinfo--cancellation--wrapper">
                            <div className="tripinfo--content tripinfo--content--heading">
                              <div className="tripinfo--left--content">
                                <h4>Time Frame</h4>
                                <span>(From scheduled flight departure)</span>
                              </div>
                              <div className="tripinfo--right--content">
                                <h4>
                                  Airline Charges + Fare Difference + TripPrizer
                                  Charges
                                </h4>
                                <span>per traveller</span>
                              </div>
                            </div>
                            <div className="tripinfo--content">
                              <div className="tripinfo--left--content">
                                <h4>0 Hours to 4 Hours</h4>
                              </div>
                              <div className="tripinfo--right--content">
                                <ul className="tripinfo--content--list">
                                  <li>
                                    <label>Adult:</label>
                                    <span className="nr--red">
                                      Non-Refundable
                                    </span>
                                  </li>
                                  <li>
                                    <label>Child:</label>
                                    <span>
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      28,885 +{" "}
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      100
                                    </span>
                                  </li>
                                  <li>
                                    <label>Infant:</label>
                                    <span>
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      28,885 +{" "}
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      100
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="tripinfo--content">
                              <div className="tripinfo--left--content">
                                <h4>4 Hours to 4 Days</h4>
                              </div>
                              <div className="tripinfo--right--content">
                                <ul className="tripinfo--content--list">
                                  <li>
                                    <label>Adult:</label>
                                    <span className="nr--red">
                                      Non-Refundable
                                    </span>
                                  </li>
                                  <li>
                                    <label>Child:</label>
                                    <span>
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      28,885 +{" "}
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      100
                                    </span>
                                  </li>
                                  <li>
                                    <label>Infant:</label>
                                    <span>
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      28,885 +{" "}
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      100
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        )}

                        {trip?.Data?.map((frame, frameIdx) => {
                          const isFrameDisabled = isTripDisabled || isFramePastOrDeparted(frame);
                          return (
                          <div
                            className="tripinfo--cancellation--wrapper"
                            key={frameIdx}
                            style={{ opacity: isFrameDisabled ? 0.5 : 1, pointerEvents: isFrameDisabled ? "none" : "auto" }}
                          >
                            <div className="tripinfo--head">
                              <div className="left--tripinfo--head">
                                <div className="left--int--ti--airlines">
                                  {ancillaryOnly && (
                                    <span style={{ fontWeight: 700, fontSize: "12px", color: "#1d4ed8", marginRight: "6px" }}>
                                      #{frameIdx + 1} SEGMENT
                                    </span>
                                  )}
                                  {frame.airlineLogos.length == 1 && (
                                    <div className="airline--img--container one--logo">
                                      <img src={frame.airlineLogos[0]} alt="" />
                                    </div>
                                  )}
                                  {frame.airlineLogos.length == 2 && (
                                    <div className="airline--img--container two--logos">
                                      <div className="twologos-firstrow">
                                        <img
                                          src={frame.airlineLogos[0]}
                                          alt=""
                                        />
                                      </div>
                                      <div className="twologos-lastrow">
                                        <img
                                          src={frame.airlineLogos[1]}
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {frame.airlineLogos.length == 3 && (
                                    <div className="airline--img--container three--logos">
                                      <div className="threelogos-firstrow">
                                        <img
                                          src={frame.airlineLogos[0]}
                                          alt=""
                                        />
                                      </div>
                                      <div className="threelogos-centerrow">
                                        <img
                                          src={frame.airlineLogos[1]}
                                          alt=""
                                        />
                                      </div>
                                      <div className="threelogos-lastrow">
                                        <img
                                          src={frame.airlineLogos[2]}
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {frame.airlineLogos.length == 4 && (
                                    <div className="airline--img--container four--logos">
                                      <div className="fourlogos-firstrow">
                                        <img
                                          src={frame.airlineLogos[0]}
                                          alt=""
                                        />
                                        <img
                                          src={frame.airlineLogos[1]}
                                          alt=""
                                        />
                                      </div>
                                      <div className="fourlogos-lastrow">
                                        <img
                                          src={frame.airlineLogos[2]}
                                          alt=""
                                        />
                                        <img
                                          src={frame.airlineLogos[3]}
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                  )}

                                  <ul className="left-int--tripinfo--airline">
                                    {frame.airlineNames?.map((i) => (
                                      <li>{i}</li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="sep">|</div>
                                <ul className="left-int--tripinfo--route">
                                  <li>{frame.journey.from}</li>
                                  <li>{frame.journey.to}</li>
                                </ul>
                              </div>
                              <div className="right--tripinfo--head">
                                <label for="">Fare Type :</label>
                                <span>{frame.fareName || "Normal Fare"}</span>
                              </div>
                            </div>

                            {!ancillaryOnly && MainForm?.data?.form_data?.length > 1 && (
                              <>
                                <div className="tripinfo--content tripinfo--content--heading">
                                  <div className="tripinfo--left--content">
                                    <h4>Time Frame</h4>
                                    <span>
                                      (From scheduled flight departure)
                                    </span>
                                  </div>
                                  <div className="tripinfo--right--content">
                                    <h4>
                                      Airline Charges + Fare Difference +
                                      TripPrizer Charges
                                    </h4>
                                    <span>per traveller</span>
                                  </div>
                                </div>
                                <div className="tripinfo--content">
                                  <div className="tripinfo--left--content">
                                    <h4>0 Hours to 4 Hours</h4>
                                  </div>
                                  <div className="tripinfo--right--content">
                                    <ul className="tripinfo--content--list">
                                      <li>
                                        <label>Adult:</label>
                                        <span className="nr--red">
                                          Non-Refundable
                                        </span>
                                      </li>
                                      <li>
                                        <label>Child:</label>
                                        <span>
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          28,885 +{" "}
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          100
                                        </span>
                                      </li>
                                      <li>
                                        <label>Infant:</label>
                                        <span>
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          28,885 +{" "}
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          100
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="tripinfo--content">
                                  <div className="tripinfo--left--content">
                                    <h4>4 Hours to 4 Days</h4>
                                  </div>
                                  <div className="tripinfo--right--content">
                                    <ul className="tripinfo--content--list">
                                      <li>
                                        <label>Adult:</label>
                                        <span className="nr--red">
                                          Non-Refundable
                                        </span>
                                      </li>
                                      <li>
                                        <label>Child:</label>
                                        <span>
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          28,885 +{" "}
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          100
                                        </span>
                                      </li>
                                      <li>
                                        <label>Infant:</label>
                                        <span>
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          28,885 +{" "}
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          100
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </>
                            )}

                            <div className="tripinfo--content">
                              <div className="tripinfo--reschedule--content">
                                <table cellpadding="0" cellspacing="0">
                                  <thead>
                                    <tr>
                                      <th width="300">
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <label
                                          className="tablecheckbox"
                                          htmlFor={`${trpIdx}-${frameIdx}-top`}
                                          style={{ display: "inline-flex", alignItems: "center" }}
                                        >
                                          <input
                                            type="checkbox"
                                            id={`${trpIdx}-${frameIdx}-top`}
                                            disabled={readOnly || isFrameDisabled}
                                            checked={(() => {
                                              const unblocked = frame.travellers.filter((t) => !t.is_blocked);
                                              // .every() on an empty array is vacuously true — with no
                                              // selectable travellers at all, that made this "select all"
                                              // header checkbox render checked despite nothing selected.
                                              return unblocked.length > 0 && unblocked.every((t) =>
                                                selectedTravellers.includes(t.ref_id)
                                              );
                                            })()}
                                            onChange={(e) => {
                                              const isChecked = e.target.checked;
                                              const unblocked = frame.travellers.filter((t) => !t.is_blocked);
                                              const ids = unblocked.map((t) => t.ref_id);
                                              const sts = unblocked.flatMap((t) => t.statusTypes);
                                              if (isChecked) {
                                                setSelectedTravelers((prev) => Array.from(new Set([...prev, ...ids])));
                                                setSelectedStatuses((prev) => Array.from(new Set([...prev, ...sts])));
                                              } else {
                                                setSelectedTravelers((prev) => prev.filter((id) => !ids.includes(id)));
                                                setSelectedStatuses((prev) => prev.filter((st) => !sts.includes(st)));
                                                setTravellerWantFields((prev) => {
                                                  const next = { ...prev };
                                                  ids.forEach((id) => delete next[id]);
                                                  return next;
                                                });
                                              }
                                            }}
                                          />
                                          <img src={CheckBlueIcon} alt="" />
                                        </label>
                                        <span>Traveller (s)</span>
                                        </div>
                                      </th>
                                      <th>E-Ticket No.</th>
                                      <th>PNR</th>
                                      {!ancillaryOnly && <th>
                                        Reschedule Date{" "}
                                        <img
                                          src={CalenderIcon}
                                          alt="Set date for all"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            const enabledTravellers =
                                              frame.travellers.filter(
                                                (trv) =>
                                                  !isFrameDisabled &&
                                                  !(trv.is_blocked && !trv.available_for_other_enquiry) &&
                                                  selectedTravellers.includes(trv.ref_id)
                                              );
                                            if (enabledTravellers.length === 0) {
                                              alert("No enabled travellers to set dates for");
                                              return;
                                            }
                                            setOpenBulkDP({
                                              tripIndex: trpIdx,
                                              frameIndex: frameIdx,
                                              travellerIds: enabledTravellers.map((t) => t.ref_id),
                                              date_1: null,
                                              date_2: null,
                                              minDate: getMinDateForFrame(trpIdx, frameIdx, enabledTravellers),
                                            });
                                          }}
                                        />
                                      </th>}
                                      {ancillaryOnly && <th style={{ minWidth: "120px" }}>Seat / Meal / Bag / Wheelchair</th>}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {frame.travellers.map((trv, trvIdx) => {
                                      const trvIds = trv.ref_id ? trv.ref_id.toString().split("-").map(Number) : [];
                                      const isThisEnquirySelected = readOnly && trvIds.some((id) => selectedEnquiryTravellerIds.includes(id));
                                      return (
                                        <tr key={trvIdx} style={isThisEnquirySelected ? { background: "#f3c954", cursor: "not-allowed" } : {}}>
                                          <td style={isThisEnquirySelected ? { cursor: "not-allowed" } : {}}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <label
                                              className="tablecheckbox"
                                              htmlFor={`trv-${trpIdx}-${frameIdx}-${trvIdx}`}
                                              title={isThisEnquirySelected ? "Selected for this request" : trv.block_reason_text}
                                              style={{ display: "inline-flex", alignItems: "center", cursor: isThisEnquirySelected ? "not-allowed" : "pointer" }}
                                            >
                                              <input
                                                type="checkbox"
                                                id={`trv-${trpIdx}-${frameIdx}-${trvIdx}`}
                                                disabled={
                                                  readOnly ||
                                                  isFrameDisabled ||
                                                  ((trv.is_blocked && !trv.available_for_other_enquiry) && !trv.available_for_other_enquiry) ||
                                                  isThisEnquirySelected
                                                }
                                                checked={selectedTravellers.includes(trv.ref_id)}
                                                onChange={(e) => {
                                                  const isChecked = e.target.checked;
                                                  if (isChecked) {
                                                    setSelectedTravelers((prev) => Array.from(new Set([...prev, trv.ref_id])));
                                                    setSelectedStatuses((prev) => Array.from(new Set([...prev, ...trv.statusTypes])));
                                                  } else {
                                                    setSelectedTravelers((prev) => prev.filter((id) => id !== trv.ref_id));
                                                    setSelectedStatuses((prev) => prev.filter((st) => !trv.statusTypes.includes(st)));
                                                    setTravellerWantFields((prev) => {
                                                      const next = { ...prev };
                                                      delete next[trv.ref_id];
                                                      return next;
                                                    });
                                                    setMainForm((prev) => {
                                                      const copy = structuredClone(prev);
                                                      copy.data.form_data.forEach((trip) => {
                                                        trip.Data.forEach((frame) => {
                                                          frame.travellers.forEach((t) => {
                                                            if (t.ref_id === trv.ref_id) {
                                                              t.reschedule_date_1 = null;
                                                              t.reschedule_date_2 = null;
                                                            }
                                                          });
                                                        });
                                                      });
                                                      return copy;
                                                    });
                                                  }
                                                }}
                                              />
                                              <img src={CheckBlueIcon} alt="" />
                                            </label>
                                            <span>{trv.full_name}</span>
                                            </div>
                                          </td>
                                          <td style={isThisEnquirySelected ? { cursor: "not-allowed" } : {}}>{trv.ticket_number || "-"}</td>
                                          <td style={isThisEnquirySelected ? { cursor: "not-allowed" } : {}}>{trv.pnr || "-"}</td>
                                          {!ancillaryOnly && <td>
                                            <div
                                              className="input--cal"
                                              title={trv.block_reason_text}
                                            >
                                              {/* <div
                                                onClick={() => {
                                                  if (
                                                    isTripDisabled ||
                                                    (trv.is_blocked && !trv.available_for_other_enquiry)
                                                  )
                                                    return;

                                                  setOpenDP({
                                                    tripIndex: trpIdx,
                                                    frameIndex: frameIdx,
                                                    travellerId: trv.ref_id,
                                                    date_1: trv.reschedule_date_1 || null,
                                                    date_2: trv.reschedule_date_2 || null,
                                                    minDate: getMinDateForTraveller(trpIdx, frameIdx, trv),
                                                  });
                                                }}
                                                className={`inputdate ${
                                                  isTripDisabled ||
                                                  (trv.is_blocked && !trv.available_for_other_enquiry)
                                                    ? "disabled"
                                                    : ""
                                                }`}
                                              >
                                                {trv.reschedule_date_1}{" "}
                                                {trv.reschedule_date_2 &&
                                                  ` - ${trv.reschedule_date_2}`}{" "}
                                                <img
                                                  src={CalenderIcon}
                                                  alt=""
                                                />
                                              </div> */}

                                              <div
                                                onClick={() => {
                                                  if (
                                                    isFrameDisabled ||
                                                    (trv.is_blocked && !trv.available_for_other_enquiry) ||
                                                    !selectedTravellers.includes(trv.ref_id)
                                                  )
                                                    return;

                                                  setOpenDP({
                                                    tripIndex: trpIdx,
                                                    frameIndex: frameIdx,
                                                    travellerId: trv.ref_id,
                                                    date_1: trv.reschedule_date_1 || null,
                                                    date_2: trv.reschedule_date_2 || null,
                                                    minDate: getMinDateForTraveller(trpIdx, frameIdx, trv),
                                                  });
                                                }}
                                                className={`inputdate
                                                      ${isFrameDisabled ||
                                                    (trv.is_blocked && !trv.available_for_other_enquiry) ||
                                                    !selectedTravellers.includes(trv.ref_id)
                                                    ? "disabled"
                                                    : ""
                                                  }
                                                      ${isDateMissingForTraveller(
                                                    trv
                                                  )
                                                    ? "error"
                                                    : ""
                                                  }
                                                    `}
                                              >
                                                {trv.reschedule_date_1 ? (
                                                  <>
                                                    {trv.reschedule_date_1}
                                                    {trv.reschedule_date_2 &&
                                                      ` - ${trv.reschedule_date_2}`}
                                                  </>
                                                ) : (
                                                  <span className="placeholder">
                                                    Select date *
                                                  </span>
                                                )}
                                                <img
                                                  src={CalenderIcon}
                                                  alt=""
                                                />
                                              </div>
                                            </div>
                                            {isDateMissingForTraveller(trv) && (
                                              <div className="error-text">
                                                Reschedule date is mandatory
                                              </div>
                                            )}
                                          </td>}
                                          {/* Seat / Meal / Bag — single combined cell. Bag is a per-trip
                                              (not per-segment) selection, so it only shows on the trip's
                                              first segment. If this row is locked by another enquiry,
                                              show what was actually requested there (read-only) instead
                                              of blank/editable checkboxes. */}
                                          {ancillaryOnly && <td style={{ verticalAlign: "top", paddingTop: "4px" }}>
                                            {(() => {
                                              const isLocked = trv.is_blocked && !trv.available_for_other_enquiry;
                                              if (isLocked) {
                                                const rows = ["seat", "meal", "wheelchair", ...(frameIdx === 0 ? ["bag"] : [])]
                                                  .filter((type) => trv[`want_${type}`]);
                                                if (rows.length === 0) return <span style={{ color: "#cbd5e1", fontSize: "11px" }}>—</span>;
                                                return rows.map((type) => (
                                                  <div key={type} style={{ display: "flex", alignItems: "center", gap: "4px", marginBottom: "4px", fontSize: "11px" }}>
                                                    <span style={{ fontWeight: 700, color: "#166534", textTransform: "uppercase", minWidth: "34px" }}>✓ {type}</span>
                                                    {type !== "wheelchair" && <span style={{ color: "#334155" }}>{trv[`wanted_${type}_value`] || "—"}</span>}
                                                  </div>
                                                ));
                                              }
                                              return ["seat", "meal", "wheelchair", ...(frameIdx === 0 ? ["bag"] : [])].map((type) => {
                                              const wantKey = `want_${type}`;
                                              const valKey = `wanted_${type}_value`;
                                              // In ancillary mode the backend scopes trv.ref_id to
                                              // this single segment only, so ref_id is already the
                                              // correct per-segment key.
                                              const stateKey = trv.ref_id;
                                              const w = travellerWantFields[stateKey] || {};
                                              const isChecked = !!w[wantKey];
                                              const isDisabled = readOnly || isFrameDisabled || (trv.is_blocked && !trv.available_for_other_enquiry) || !selectedTravellers.includes(trv.ref_id);
                                              return (
                                                <div key={type} style={{ display: "flex", alignItems: "center", gap: "4px", marginBottom: "4px" }}>
                                                  <label style={{ display: "flex", alignItems: "center", gap: "3px", cursor: isDisabled ? "not-allowed" : "pointer", opacity: isDisabled ? 0.5 : 1, minWidth: "48px" }}>
                                                    <input
                                                      type="checkbox"
                                                      disabled={isDisabled}
                                                      checked={isChecked}
                                                      onChange={(e) => {
                                                        if (isDisabled) return;
                                                        setTravellerWantFields((prev) => ({
                                                          ...prev,
                                                          [stateKey]: {
                                                            ...(prev[stateKey] || {}),
                                                            [wantKey]: e.target.checked,
                                                            ...(e.target.checked ? {} : { [valKey]: "" }),
                                                          },
                                                        }));
                                                      }}
                                                    style={{ cursor: isDisabled ? "not-allowed" : "pointer", width: "12px", height: "12px", accentColor: "#0f154d" }}
                                                    />
                                                    <span style={{ textTransform: "capitalize" }}>{type}</span>
                                                  </label>
                                                  {type !== "wheelchair" && <input
                                                    type="text"
                                                    disabled={isDisabled || !isChecked}
                                                    value={w[valKey] || ""}
                                                    placeholder={type === "seat" ? "Seat pref." : type === "meal" ? "Meal pref." : "Bag pref."}
                                                    onChange={(e) =>
                                                      setTravellerWantFields((prev) => ({
                                                        ...prev,
                                                        [stateKey]: { ...(prev[stateKey] || {}), [valKey]: e.target.value },
                                                      }))
                                                    }
                                                    style={{ width: "80px", padding: "2px 5px", border: "1px solid #cbd5e1", borderRadius: "4px", opacity: isChecked ? 1 : 0.35 }}
                                                  />}
                                                </div>
                                              );
                                              });
                                            })()}
                                          </td>}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        );
                        })}

                        {!ancillaryOnly && (<><div className="choose--docs" style={{ flexDirection: "column", gap: "8px" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                            <div className="left--docs--heading">
                              <h3>Documents <span>(Optional)</span></h3>
                              <p>Attach documents for this trip.</p>
                            </div>
                            {!readOnly && (
                              <label style={{
                                display: "inline-flex", alignItems: "center", gap: "4px",
                                fontSize: "11px", color: "#555", cursor: "pointer",
                                border: "1px solid #ccc", borderRadius: "4px",
                                padding: "4px 10px", background: "#fff", userSelect: "none",
                              }}>
                                <span>📎</span> Attach files
                                <input type="file" multiple style={{ display: "none" }}
                                  onChange={(e) => handleDocumentChange(`trip_${trpIdx + 1}`, e.target.files)}
                                />
                              </label>
                            )}
                          </div>

                          {Documents[`trip_${trpIdx + 1}`]?.length > 0 && (
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "4px" }}>
                              {Documents[`trip_${trpIdx + 1}`].map((doc, idx) => (
                                <div key={idx} style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                                  <a
                                    href={doc.isExisting ? fixUrl(doc.url) : doc.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      display: "inline-flex", alignItems: "center", gap: "5px",
                                      fontSize: "11px", color: "#1565c0", textDecoration: "none",
                                      background: "#e3f2fd", borderRadius: "4px", padding: "3px 8px",
                                      border: "1px solid #bbdefb",
                                    }}
                                  >
                                    <span>{doc.name.endsWith(".pdf") ? "📄" : "🖼️"}</span>
                                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "160px" }}>{doc.name}</span>
                                    {doc.isExisting && <span style={{ fontSize: "10px", color: "#388e3c", fontWeight: 600 }}>✓</span>}
                                  </a>
                                  {!doc.isExisting && !readOnly && (
                                    <button type="button" onClick={() => removeDocument(`trip_${trpIdx + 1}`, idx)}
                                      style={{ background: "none", border: "none", cursor: "pointer", color: "#e53935", fontSize: "13px", padding: "0 2px", lineHeight: 1 }}>
                                      ✕
                                    </button>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        <div className="remarks--popup--userdb">
                          <label for="textarea--remarks">Remarks:</label>
                          <textarea
                            name=""
                            id=""
                            disabled={readOnly || isTripDisabled}
                            placeholder="Remarks"
                            value={Remarks[`user_remarks_${trpIdx + 1}`]}
                            onChange={(e) =>
                              setRemarks((prev) => ({
                                ...prev,
                                [`user_remarks_${trpIdx + 1}`]: e.target.value,
                              }))
                            }
                          ></textarea>
                        </div>

                        <div
                          className="acceptcb"
                          onClick={() =>
                            !readOnly && setProceedMode((prev) => ({
                              ...prev,
                              [`proceed_mode_${trpIdx + 1}`]:
                                ProceedMode[`proceed_mode_${trpIdx + 1}`] != 1
                                  ? 1
                                  : 0,
                            }))
                          }
                        >
                          <input
                            disabled={readOnly || isTripDisabled}
                            type="checkbox"
                            checked={
                              ProceedMode[`proceed_mode_${trpIdx + 1}`] == 1
                            }
                          />{" "}
                          <label for="acceptfr">
                            Proceed by Ignoring Remarks
                          </label>
                        </div>

                        <div className="trips--flightdetails--summary">
                          <h3>Terms & Conditions:</h3>
                          <ul className="trips--fd--list">
                            <li>
                              The airline fee is indicative. TripPrizers does
                              not guarantee the accuracy of this information.
                            </li>
                            <li>
                              All fees mentioned are per passenger. Date change
                              charges are applicable only on selecting the same
                              airline on a new date. The difference in fares
                              between the old and the new booking will also be
                              payable by the user.
                            </li>
                            <li>
                              Please refer to the Date Change Charges section
                              above for details on the number of allowed free
                              date changes, if applicable
                            </li>
                          </ul>
                        </div>
                        </>)}
                      </>
                    )}
                  </div>
                </div>
              );
            })}
            </div>{/* end pointer-events wrapper */}
          </div>

          {showbottombar == true && !readOnly && (
            <div className="action--bar--bottom">
              {allTripsDisabled && (
                <div className="trip-disabled-warning">
                  All flights have already departed. Rescheduling is no longer allowed.
                </div>
              )}
              {!allTripsDisabled && !ancillaryOnly && (
                <div className="acceptcb" onClick={() => setAcceptFareRules(!AcceptFareRules)}>
                  <input type="checkbox" checked={AcceptFareRules}
                    disabled={autoFill?.autoFilled == true && autoFill.data.submittion_type != "admin"} />{" "}
                  <label>I Accept The Fare Rules.</label>
                </div>
              )}
              {!allTripsDisabled && (
                <button
                  className="ac-submitbtn"
                  style={{ cursor: autoFill?.autoFilled == true && autoFill.data.submittion_type != "admin" ? "not-allowed" : "pointer", width: "max-content" }}
                  disabled={submitting || allTripsDisabled || hasMissingDates() || (autoFill?.autoFilled == true && autoFill.data.submittion_type != "admin")}
                  onClick={handleSubmit}
                >
                  {submitting ? "Submitting..." : "Proceed"}
                </button>
              )}
            </div>
          )}
          </div>

          {/* ── RIGHT: remarks panel ── */}
          {showRemarksPanel && (
            <div style={{ width: "300px", flexShrink: 0, borderLeft: "1px solid #e0e0e0", display: "flex", flexDirection: "column", background: "#fff" }}>
              <div style={{ padding: "12px 16px 10px", borderBottom: "1px solid #e0e0e0", background: "#f5f5f5" }}>
                <p style={{ margin: 0, fontWeight: 600, fontSize: "13px", color: "#333" }}>Remarks</p>
                <p style={{ margin: "2px 0 0", fontSize: "11px", color: "#888" }}>Your request is with us — add a follow-up below.</p>
              </div>
              <div style={{ flex: 1, overflowY: "auto", padding: "12px 14px", display: "flex", flexDirection: "column", gap: "10px", minHeight: 0 }}>
                {existingRemarks.length === 0 && (
                  <p style={{ fontSize: "12px", color: "#bbb", textAlign: "center", marginTop: "20px" }}>No remarks yet.</p>
                )}
                {existingRemarks.map((r, idx) => {
                  const isAdmin = !!r.admin_id;
                  const time = new Date(r.created_at).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
                  return (
                    <div key={idx} style={{ display: "flex", flexDirection: "column", alignItems: isAdmin ? "flex-start" : "flex-end" }}>
                      <div style={{
                        maxWidth: "88%",
                        background: isAdmin ? "#f0f4ff" : "#e8f5e9",
                        border: `1px solid ${isAdmin ? "#c5cae9" : "#c8e6c9"}`,
                        borderRadius: isAdmin ? "2px 10px 10px 10px" : "10px 2px 10px 10px",
                        padding: "8px 12px", boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                      }}>
                        {isAdmin && <p style={{ margin: "0 0 3px", fontSize: "10px", fontWeight: 700, color: "#5c6bc0", textTransform: "uppercase", letterSpacing: "0.4px" }}>Support</p>}
                        {r.remarks && <p style={{ margin: 0, fontSize: "12px", color: "#333", lineHeight: "1.5" }}>{r.remarks}</p>}
                        {r.attachments?.length > 0 && (
                          <div style={{ marginTop: r.remarks ? "6px" : 0, display: "flex", flexDirection: "column", gap: "4px" }}>
                            {r.attachments.map((att, ai) => {
                              const baseUrl = MAIN_URL.replace(/\/api\/?$/, "").replace(/\/$/, "");
                              const attUrl = att.file_path?.startsWith("http") ? att.file_path : `${baseUrl}${att.file_path}`;
                              return (
                              <a key={ai} href={attUrl} target="_blank" rel="noopener noreferrer"
                                style={{ display: "inline-flex", alignItems: "center", gap: "5px", fontSize: "11px", color: "#1565c0", textDecoration: "none", background: "#e3f2fd", borderRadius: "4px", padding: "3px 8px", border: "1px solid #bbdefb" }}>
                                <span>{att.file_name.endsWith(".pdf") ? "📄" : "🖼️"}</span>
                                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "160px" }}>{att.file_name}</span>
                              </a>
                            );})}
                          </div>
                        )}
                      </div>
                      <span style={{ fontSize: "10px", color: "#aaa", marginTop: "3px", paddingLeft: "4px", paddingRight: "4px" }}>{time}</span>
                    </div>
                  );
                })}
              </div>
              <div style={{ borderTop: "1px solid #e0e0e0", padding: "10px 14px 12px", display: "flex", flexDirection: "column", gap: "8px", background: "#fafafa" }}>
                <textarea rows={3} placeholder="Type your remark here..."
                  value={newRemark} onChange={(e) => setNewRemark(e.target.value)}
                  style={{ width: "100%", borderRadius: "6px", border: "1px solid #ddd", padding: "8px 10px", fontSize: "12px", resize: "none", boxSizing: "border-box", background: "#fff", outline: "none", lineHeight: "1.5", fontFamily: "inherit" }}
                />
                <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                  <label style={{ display: "inline-flex", alignItems: "center", gap: "4px", fontSize: "11px", color: "#555", cursor: "pointer", border: "1px solid #ccc", borderRadius: "4px", padding: "4px 10px", background: "#fff", userSelect: "none" }}>
                    <span>📎</span> Attach files
                    <input type="file" multiple style={{ display: "none" }} onChange={(e) => setRemarkFiles((prev) => [...prev, ...Array.from(e.target.files)])} />
                  </label>
                  {remarkFiles.map((f, fi) => (
                    <span key={fi} style={{ display: "inline-flex", alignItems: "center", gap: "4px", fontSize: "11px", background: "#e3f2fd", borderRadius: "4px", padding: "3px 8px", border: "1px solid #bbdefb", maxWidth: "120px" }}>
                      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.name}</span>
                      <button type="button" onClick={() => setRemarkFiles((prev) => prev.filter((_, i) => i !== fi))}
                        style={{ background: "none", border: "none", cursor: "pointer", color: "#c0392b", padding: 0, lineHeight: 1, flexShrink: 0 }}>✕</button>
                    </span>
                  ))}
                </div>
                <button type="button"
                  disabled={savingRemark || remarkCooldownSecs > 0 || (!newRemark.trim() && remarkFiles.length === 0)}
                  onClick={handleSaveRemark}
                  style={{
                    padding: "9px 0",
                    background: savingRemark || remarkCooldownSecs > 0 || (!newRemark.trim() && remarkFiles.length === 0) ? "#90caf9" : "#1565c0",
                    color: "#fff", border: "none", borderRadius: "6px", fontSize: "13px", fontWeight: 600,
                    cursor: savingRemark || remarkCooldownSecs > 0 || (!newRemark.trim() && remarkFiles.length === 0) ? "not-allowed" : "pointer",
                    width: "100%",
                  }}
                >
                  {savingRemark ? "Saving..." : remarkCooldownSecs > 0 ? `Wait ${Math.floor(remarkCooldownSecs / 60)}m ${remarkCooldownSecs % 60}s` : "Save Remarks"}
                </button>
              </div>
            </div>
          )}
        </div>
      )}



      {/* Individual traveller date popup */}
      <Popup1
        Open={!!openDP}
        onClose={() => setOpenDP(null)}
        Content={
          openDP && (
            <CalendarPopup
              dates={openDP}
              onClose={() => setOpenDP(null)}
              onSave={(d1, d2) => {
                console.log("d1 is: ", d1);
                console.log("d2 is: ", d2);

                setMainForm((prev) => {
                  const copy = structuredClone(prev);
                  const trip = copy.data.form_data[openDP.tripIndex];
                  if (!trip) return copy;

                  // Set date on the chosen frame
                  const chosenFrame = trip.Data[openDP.frameIndex];
                  if (chosenFrame) {
                    chosenFrame.travellers.forEach((t) => {
                      if (t.ref_id === openDP.travellerId) {
                        t.reschedule_date_1 = d1;
                        t.reschedule_date_2 = d2;
                      }
                    });
                  }

                  // Clear dates on any later frame whose same traveller (by name+dob)
                  // has a date that is now less than the newly set date.
                  const setTraveller = chosenFrame?.travellers.find((t) => t.ref_id === openDP.travellerId);
                  if (setTraveller && d1) {
                    const newIso = toISODate(d1);
                    for (let fi = openDP.frameIndex + 1; fi < trip.Data.length; fi++) {
                      trip.Data[fi].travellers.forEach((t) => {
                        if (
                          t.full_name === setTraveller.full_name &&
                          t.date_of_birth === setTraveller.date_of_birth &&
                          t.reschedule_date_1 &&
                          toISODate(t.reschedule_date_1) < newIso
                        ) {
                          t.reschedule_date_1 = null;
                          t.reschedule_date_2 = null;
                        }
                      });
                    }
                  }

                  return copy;
                });
              }}
            />
          )
        }
      />

      {/* Bulk date selection popup for all travellers in frame */}
      <Popup1
        Open={!!openBulkDP}
        onClose={() => setOpenBulkDP(null)}
        Content={
          openBulkDP && (
            <CalendarPopup
              dates={openBulkDP}
              onClose={() => setOpenBulkDP(null)}
              onSave={(d1, d2) => {
                console.log("Bulk setting dates:", d1, d2);
                console.log("For travellers:", openBulkDP.travellerIds);

                setMainForm((prev) => {
                  const copy = structuredClone(prev);
                  const trip = copy.data.form_data[openBulkDP.tripIndex];
                  if (!trip) return copy;

                  const chosenFrame = trip.Data[openBulkDP.frameIndex];
                  if (chosenFrame) {
                    chosenFrame.travellers.forEach((t) => {
                      if (openBulkDP.travellerIds.includes(t.ref_id)) {
                        t.reschedule_date_1 = d1;
                        t.reschedule_date_2 = d2;
                      }
                    });
                  }

                  // Clear invalid later-frame dates for each updated traveller
                  if (d1 && chosenFrame) {
                    const newIso = toISODate(d1);
                    const updatedTravellers = chosenFrame.travellers.filter((t) =>
                      openBulkDP.travellerIds.includes(t.ref_id)
                    );
                    for (let fi = openBulkDP.frameIndex + 1; fi < trip.Data.length; fi++) {
                      trip.Data[fi].travellers.forEach((t) => {
                        const matched = updatedTravellers.find(
                          (u) => u.full_name === t.full_name && u.date_of_birth === t.date_of_birth
                        );
                        if (matched && t.reschedule_date_1 && toISODate(t.reschedule_date_1) < newIso) {
                          t.reschedule_date_1 = null;
                          t.reschedule_date_2 = null;
                        }
                      });
                    }
                  }

                  return copy;
                });

                setOpenBulkDP(null);
              }}
            />
          )
        }
      />
    </div>
  );
}

export default ReschedulingForm;
